import { render, staticRenderFns } from "./loadingSecciones.vue?vue&type=template&id=35a565f3&"
import script from "./loadingSecciones.vue?vue&type=script&lang=js&"
export * from "./loadingSecciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports